import {MODES} from '../../IssueProfile/Modes';

export const executeIssueProfileEditAction = (parent, issueProfile) => {
    parent.props.history.push({
        pathname: '/issueProfile/editIssueProfile',
        state: {id: issueProfile.id, mode: MODES.EDIT},
    });
};
